<template>
  <v-card class="import-review-card mb-6" outlined>
    <v-card-text class="pa-5">
      <div class="import-review-header">
        <div>
          <div class="import-review-eyebrow">Import Ready</div>
          <div class="import-review-title">{{ title }}</div>
          <div class="import-review-meta">
            <span>{{ fileName }}</span>
            <span>{{ rowCount }} valid {{ rowCount === 1 ? "row" : "rows" }}</span>
          </div>
        </div>
        <v-chip color="success" outlined>
          {{ rowCount }} rows
        </v-chip>
      </div>

      <v-progress-linear
          v-if="loading"
          class="mt-4"
          color="primary"
          height="8"
          indeterminate
          rounded
      ></v-progress-linear>

      <div class="import-review-actions mt-4">
        <v-btn
            :disabled="loading"
            color="primary"
            depressed
            @click="$emit('upload')"
        >
          <v-icon left>mdi-cloud-upload</v-icon>
          {{ actionLabel }}
        </v-btn>
        <v-btn
            :disabled="loading"
            outlined
            @click="$emit('replace')"
        >
          <v-icon left>mdi-file-replace-outline</v-icon>
          Replace File
        </v-btn>
        <v-btn
            :disabled="loading"
            text
            @click="$emit('cancel')"
        >
          Cancel
        </v-btn>
      </div>

      <div class="import-review-note mt-4">
        Only validated rows will be imported. If you need changes, replace the file and upload a corrected spreadsheet.
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    actionLabel: {
      type: String,
      default: "Upload",
    },
    fileName: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    rowCount: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: "Validated spreadsheet",
    },
  },
};
</script>

<style scoped>
.import-review-card {
  border-radius: 16px;
  border-color: #cbd5e1 !important;
  background: linear-gradient(135deg, #f8fafc 0%, #eef6ff 100%);
}

.import-review-header {
  display: flex;
  gap: 16px;
  justify-content: space-between;
  align-items: flex-start;
}

.import-review-eyebrow {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #0369a1;
  margin-bottom: 6px;
}

.import-review-title {
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
}

.import-review-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
  color: #475569;
  font-size: 14px;
}

.import-review-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.import-review-note {
  color: #475569;
  font-size: 13px;
}
</style>
